import { render } from "./einDorKfarMizr.vue?vue&type=template&id=35bfabf6&scoped=true"
import script from "./einDorKfarMizr.vue?vue&type=script&lang=js"
export * from "./einDorKfarMizr.vue?vue&type=script&lang=js"

import "./einDorKfarMizr.vue?vue&type=style&index=0&id=35bfabf6&scoped=true&lang=css"

import exportComponent from "/media/rafa/mainDisk/Documents/Raphael/Development/NavigationApplication/efoani/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35bfabf6"]])

export default __exports__